module.exports = "https://activity.hdslb.com/blackboard/activity92636/img/yule-card-poster.3694e2d3.png";